// src/components/ui/card.jsx
const Card = ({ children, className })=> {
  return (
    <div className={`p-1 rounded-2xl shadow ${className}`}>
      {children}
    </div>
  );
}
  const CardContent = ({ children }) => {
    return <div className="p-1 ">{children}</div>;
  };
  
  export { Card, CardContent };
  